import { useSearchParams } from 'react-router-dom'

/**
 * 開発者ツール（DevTools）が有効か。
 * ビルド時フラグ（VITE_DEV_TOOLS_AVAILABLE）と URL パラメータ（?devtools=true）の
 * 両方が揃ったときだけ true。視点切替などの開発者向け機能の出し分けに使う。
 */
export const useDevToolsEnabled = (): boolean => {
  const [searchParams] = useSearchParams()
  return (
    import.meta.env.VITE_DEV_TOOLS_AVAILABLE === 'true' &&
    searchParams.get('devtools') === 'true'
  )
}
